import { Button, Input } from "components/form";
import React, { useState } from "react";
import {
  FaFacebookF,
  FaRegCopy,
  FaRegEnvelope,
  FaRegShareSquare,
  FaWhatsapp,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import "../CreateSurvey.scss";
import {
  handleDecryptionParams,
  handleEncryptionParams,
} from "utils/dataCipherHelper";
import {
  Link,
  useNavigate,
  useNavigation,
  useSearchParams,
} from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { CiGlobe } from "react-icons/ci";
import { successImg } from "assets/images";
import { getFromLocal } from "config/axiosInstance";
import { createSurveyApi } from "services/survey";
import { removeEmptyValues } from "utils/commonHelper";
import { toastMessage } from "utils/toastMessageHelper";
import { useTranslation } from "react-i18next";
import { IoIosArrowDown } from "react-icons/io";
import { MdInfoOutline } from "react-icons/md";

const PublishSurvey = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const getParamsData = handleDecryptionParams(
    searchParams.get("data"),
    setSearchParams
  );

  const selectedSurveyId = getParamsData?.surveySlug || "";
  const publishSurvey = getParamsData?.publishSurvey;

  const { t } = useTranslation();

  // Set all value
  // const [isPublicSurvey, setIsPublicSurvey] = useState(publishSurvey);

  // fucntion handler

  // Publish Status handler

  const publishStatusHandler = (status) => {
    if (publishSurvey !== status) {
      // setIsPublicSurvey(status);
      createSurveyHandler(status);
      const paramsData = { ...getParamsData, publishSurvey: status };
      const currentEncryptedParams = handleEncryptionParams(paramsData, null);
      navigate(`?data=${currentEncryptedParams}`, {
        replace: true,
      });
    }
  };

  // // Create Survey function handler
  const createSurveyHandler = async (isPublicSurvey) => {
    //  if (validation()) {
    try {
      // setCreateNewSurveyLoading(true);
      const reqData = {
        publishSurvey: isPublicSurvey,
        token: getFromLocal() || "",
        surveyId: selectedSurveyId,
      };
      const responseData = await createSurveyApi(removeEmptyValues(reqData));
      const { message = "", status: requstStatus } = responseData;
      if (requstStatus === 200) {
        toastMessage(message, "success", "createNewSurvey");
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      // setCreateNewSurveyLoading(false);
    }
  };

  // redirect handler
  const reDirectHandler = () => {
    const paramsData = {
      stepper: 2,
    };
    const encryptedParams = handleEncryptionParams(paramsData, searchParams);
    setSearchParams(encryptedParams);
    navigate("/dashboard/create-survey");
  };

  //************************* Handle HTML CODE ********************//
  return (
    <div className="participant_criteria publish_survey">
      <h3 className="dashboard_title">{t("PUBLISH_SURVEY.publishSurvey")}</h3>
      <div className="form_wrap">
        <div className="form_content">
          <form>
            {/* Step 1: Survey Details */}
            <div className="form_section">
              <div className="form_title">
                <h4>
                  <span className="sr_number">1</span>
                  {t("PUBLISH_SURVEY.surveyUrl")}
                </h4>
                <div className="button_wrap">
                  <button type="button">
                    <FaRegCopy />
                    {t("PUBLISH_SURVEY.copyLink")}
                  </button>
                  <button type="button">
                    <FaRegShareSquare />
                    {t("PUBLISH_SURVEY.open")}
                  </button>
                </div>
              </div>
              <div className="form_field">
                <Input
                  type="url"
                  name="title"
                  value={"https://example.com"}
                  // placeholder="Enter survey title..."
                  isDisabled={true}
                />
              </div>
            </div>

            {/* Step 2: Survey Overview */}
            <div className="form_section">
              <div className="form_title d-block">
                <div className="has_child w-100">
                  <h4>
                    <span className="sr_number">2</span>
                    {t("PUBLISH_SURVEY.surveyOverview")}
                  </h4>
                  <div className="survey_type_dropdown">
                    <Dropdown className="custom_dropdown">
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <CiGlobe />{" "}
                        <span>
                          {publishSurvey
                            ? t("PUBLISH_SURVEY.publicSurvey")
                            : t("PUBLISH_SURVEY.privateSurvey")}
                        </span>
                        <IoIosArrowDown className="dropdown_arrow" />
                        {/* <span>{t("PUBLISH_SURVEY.publicSurvey")}</span> */}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {!publishSurvey ? (
                          <Dropdown.Item
                            onClick={() => publishStatusHandler(true)}
                          >
                            {t("PUBLISH_SURVEY.publicSurvey")}
                          </Dropdown.Item>
                        ) : (
                          <Dropdown.Item
                            onClick={() => publishStatusHandler(false)}
                          >
                            {t("PUBLISH_SURVEY.privateSurvey")}
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                <div className="info_text_wrap">
                  <p className="info_text">
                    <MdInfoOutline /> {t("PUBLISH_SURVEY.surveyOverviewInfo")}
                  </p>
                </div>
              </div>
              <div className="share_icons">
                <ul>
                  <li>
                    <Link to="" className="whatsapp">
                      <FaWhatsapp />
                    </Link>
                  </li>
                  <li>
                    <Link to="" className="facebook">
                      <FaFacebookF />
                    </Link>
                  </li>
                  <li>
                    <Link to="" className="twitter">
                      <FaXTwitter />
                    </Link>
                  </li>
                  <li>
                    <Link to="" className="email">
                      <FaRegEnvelope />
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="button_wrap">
                {/* <Link type="button" className="button" to={"/"}>
                  Go to Home Page
                </Link> */}

                <Button
                  type="button"
                  className="button"
                  onClick={() => navigate("/dashboard/create-survey")}
                >
                  {t("PUBLISH_SURVEY.goHomePage")}
                </Button>

                {/* <button type="button" className="button" disabled>
                  Check Analysis
                </button> */}
                {/* <Link
                  // to={"/dashboard/create-survey"}
                  type="button"
                  className="button active"
                  onClick={reDirectHandler}
                  // loading={createNewSurveyLoading}
                  // onClick={createSurveyHandler}
                >
                  Create New Survey
                </Link> */}

                <Button
                  type="button"
                  className="button active"
                  onClick={reDirectHandler}
                >
                  {t("PUBLISH_SURVEY.createNewSurvey")}
                </Button>
              </div>
            </div>
          </form>
        </div>

        <div className="form_summery_wrap">
          <img src={successImg} alt="" />
          <h3>{t("PUBLISH_SURVEY.congratulation")}</h3>
          <p>{t("PUBLISH_SURVEY.congratulationDescription")}</p>
        </div>
      </div>
    </div>
  );
};

export default PublishSurvey;
